import ParlorContainer from "containers/Parlor/ParlorContainer";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  const description = "전국 1100여 개의 장례식장 중 나에게 맞는 최적의 장례식장을 찾아보세요.";

  return {
    props: {
      pageDescription: description,
      pageKeywords:
        "장례식장 비교, 장례식장 이용료, 장례비용, 장례식비용, 장례식장비용, 평균 장례비용",
      pageOgTitle: "나에게 맞는 최적의 장례식장 찾기 - [장례의 모든 것, 고이장례연구소]",
      pageOgDescription: description,
    },
  };
};

function Parlors() {
  return (
    <>
      <ParlorContainer />
    </>
  );
}

export default Parlors;
